import { underwritingApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const UNDERWRITING_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/underwriting`,
  {
    GET_UNDERWRITING_DATA: 'GET_UNDERWRITING_DATA',
    EDIT_EXPIRATION_DATES_DATA: 'EDIT_EXPIRATION_DATES_DATA',
    EDIT_NOTES_DATA: 'EDIT_NOTES_DATA',
  },
);

export const getUnderwritingDataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingApi.getLoanUnderwritingByLoanId(params);

  return dispatch({
    type: UNDERWRITING_ACTION_TYPE.GET_UNDERWRITING_DATA,
    payload: data,
  });
});

export const editExpirationDatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingApi.editLoanUnderwritingExpirationDates(params);

  return dispatch({
    type: UNDERWRITING_ACTION_TYPE.EDIT_EXPIRATION_DATES_DATA,
    payload: data,
  });
});

export const editNotesDataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await underwritingApi.editLoanUnderwritingManualNotes(params);

  return dispatch({
    type: UNDERWRITING_ACTION_TYPE.EDIT_NOTES_DATA,
    payload: data,
  });
});
